<nz-spin nzSize="large"></nz-spin>